import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { Section } from './Section';
import { faqs } from '../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <Section tone="parchment" title="Preguntas frecuentes" width="narrow" data-id="element-54" data-mp="1gcpfsz39k8rr">
      <ul className="mx-auto max-w-3xl space-y-3" data-id="element-55" data-mp="1gal0lkzwznc6">
        {faqs.map((faq, index) => {
        const isOpen = open === index;
        const panelId = `faq-panel-${index}`;
        return <li key={faq.question} className="overflow-hidden rounded-2xl bg-ivory ring-1 ring-line" data-id="element-56" data-mp="28za4tsw9o8s5" data-mpi={index}>
              <h3 data-id="element-57" data-mp="244cw6n2wg1fs">
                <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={panelId} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] hover:bg-cream focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-inset focus-visible:ring-gold/50 md:px-7 md:py-5" data-id="element-58" data-mp="1z3732o5buc5q">
                  <span className="text-base font-semibold text-ink md:text-lg" data-id="element-59" data-mp="fk9vnz1j39wy">{faq.question}</span>
                  <PlusIcon className={`h-5 w-5 shrink-0 text-wine transition-transform duration-200 ease-[cubic-bezier(0.23,1,0.32,1)] ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-60" data-mp="kibmj6574diz" />
                </button>
              </h3>
              <AnimatePresence initial={false} data-id="element-61" data-mp="3szziijs14owq">
                {isOpen && <motion.div id={panelId} initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-62" data-mp="1tett6pg5t2v">
                    <p className="px-5 pb-5 text-muted md:px-7 md:pb-6 md:text-lg" data-id="element-63" data-mp="1ppmcuz77oocv">{faq.answer}</p>
                  </motion.div>}
              </AnimatePresence>
            </li>;
      })}
      </ul>
    </Section>;
}